import { ThunkAction } from 'redux-thunk';

import { Dependent } from 'types';

import { api2 } from '../apis'

import moment from 'moment';

import {
  DEPENDENTS_ADD,
  DEPENDENTS_ADD_ONE,
  DEPENDENTS_LOADING,
  DEPENDENTS_LOADED,
  DEPENDENT_UPDATE,
  DEPENDENT_DETAILED,
  DEPENDENT_RESET,
  DEPENDENTS_FAILURE,
  DEPENDENT_REQUESTS_LOADING,
  DEPENDENT_REQUESTS_LOADED,
  DEPENDENT_REQUESTS_FAILURE,
  DEPENDENT_REQUESTS_RESET,
  RESET_ERROR,
} from 'store/types/dependents.type';

import { State } from 'store/reducers/dependents.reducer';


export const resetError = () => ({
  type: RESET_ERROR
})
export const dependentsAdd = (data: Dependent[]) => ({
  type: DEPENDENTS_ADD,
  data,
});

export const dependentsFailure = (error: string) => ({
  type: DEPENDENTS_FAILURE,
  error,
});

export const dependentsIsLoading = () => ({
  type: DEPENDENTS_LOADING,
});

export const dependentsLoaded = () => ({
  type: DEPENDENTS_LOADED
})

export const dependentsAddOne = (item: Dependent) => ({
  type: DEPENDENTS_ADD_ONE,
  item,
});

export const dependentUpdate = (item: Dependent) => ({
  type: DEPENDENT_UPDATE,
  item,
});

export const dependentDetailed = (item: Dependent) => ({
  type: DEPENDENT_DETAILED,
  item,
});

/** Dependent Requests */
export const requestsLoading = (id: any) => ({
  type: DEPENDENT_REQUESTS_LOADING,
  id
})
export const requestsLoaded = (id: any, requests: any, totalPages: number) => ({
  type: DEPENDENT_REQUESTS_LOADED,
  id, requests, totalPages
})
export const requestsFailure = (id: any, error: string) => ({
  type: DEPENDENT_REQUESTS_FAILURE,
  id, error
})

export const resetDependentRequests = () => ({ type: DEPENDENT_REQUESTS_RESET })
export const dependentReset = () => ({ type: DEPENDENT_RESET })

export type Actions =
  | ReturnType<typeof dependentsAdd>
  | ReturnType<typeof dependentsFailure>
  | ReturnType<typeof dependentsIsLoading>
  | ReturnType<typeof dependentsLoaded>
  | ReturnType<typeof dependentsAddOne>
  | ReturnType<typeof dependentUpdate>
  | ReturnType<typeof dependentReset>
  | ReturnType<typeof dependentDetailed>
  | ReturnType<typeof requestsLoading>
  | ReturnType<typeof requestsLoaded>
  | ReturnType<typeof requestsFailure>
  | ReturnType<typeof resetDependentRequests>
  | ReturnType<typeof resetError>;

type ThunkResult<R> = ThunkAction<R, State, undefined, Actions>;

export type DependentApiValues = {
  id: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  dob: string;
  gender: string;
  age: string;
  grade: string;
  school: string;
  sport: string;
  relation?: string
};

const convertDependent = (item: DependentApiValues) => ({
  id: `${item.id}`,
  firstName: item.first_name ? item.first_name : '',
  middleName: item.middle_name ? item.middle_name : '',
  lastName: item.last_name ? item.last_name : '',
  birthday: item.dob ? moment(item.dob).format(process.env.REACT_APP_DATE_FORMAT) : '',
  sex: item.gender ? item.gender : '',
  age: item.age ? item.age : '',
  grade: item.grade ? item.grade : '',
  school: item.school ? item.school : '',
  sport: item.sport ? item.sport : '',
  relation: item.relation || ''
});

export const dependentsFetch = (): ThunkResult<void> => async dispatch => {
  dispatch(dependentsIsLoading());

  api2
    .get('/api/v2/patient/dependents')(dispatch)
    .then(res => {
      dispatch(dependentsAdd(res.dependents.map(convertDependent)));
    })
    .catch(error => dispatch(dependentsFailure(error)));
};

export const dependentDeatils = (id: any): ThunkResult<void> => async dispatch => {
  dispatch(dependentsIsLoading());

  api2
    .get(`/api/v2/patient/dependents/${id.id}`)(dispatch)
    .then(res => {
      dispatch(dependentDetailed(convertDependent(res.dependent)));
    })
    .catch(error => dispatch(dependentsFailure(error)));
};

export const dependentsCreate = (data: any, callback?: (dependend: any) => void): ThunkResult<void> => async dispatch => {
  dispatch(dependentsIsLoading());
  api2
    .post('/api/v2/patient/dependents', data)(dispatch)
    .then((res: any) => {
      dispatch(dependentDetailed(convertDependent(res.dependent)));
      dispatch(dependentsLoaded())
      callback && callback(res?.dependent)
    })
    .catch(error => dispatch(dependentsFailure(error)));
};

export const dependentsUpdate = (data: any, callback?: () => void): ThunkResult<void> => async dispatch => {
  dispatch(dependentsIsLoading());
  api2
    .put(`/api/v2/patient/dependents/${data.id}`, data)(dispatch)
    .then(res => {
      dispatch(dependentDeatils(data))
      dispatch(dependentsFetch());
      callback && callback()
    })
    .catch(error => dispatch(dependentsFailure(error)));
};

export const dependentsDelete = (id: string, callback: () => void): ThunkResult<void> => async dispatch => {
  dispatch(dependentsIsLoading());
  api2
    .delete(`/api/v2/patient/dependents/${id}`)(dispatch)
    .then(res => {
      dispatch(dependentsFetch());
      callback()
    })
    .catch(error => dispatch(dependentsFailure(error)));
};

export const fetchDependentRequests = (id: any, params: any): ThunkResult<void> => dispatch => {
  dispatch(requestsLoading(id));
  api2
    .get('/api/v2/requests', { params })(dispatch)
    .then(res => {
      dispatch(requestsLoaded(id, res.requests, res.total_pages));
    })
    .catch(error => dispatch(requestsFailure(id, error.message)));
}
